import React from 'react';
import BaseNode from './BaseBlockNode';
import { renderValue } from '../../helpers/node';
import { useBaseStyles } from './style';
import { detectDemoMode } from '../../../Demo/helper';
import { renderPhasesParams } from '../../../constants/phases';

const isDemo = detectDemoMode();

function InactiveMarker() {
  const styles = useBaseStyles();

  return (
    <foreignObject className={styles.inactiveMarker}>
      <span className={styles.inactiveMarkerIcon}>!</span>
      <span className={styles.inactiveMarkerText}>This charger is inactive</span>
    </foreignObject>
  );
}

function ChargerNode(props) {
  const {
    chargerUuid,
    nominalVoltage,
    offlineCurrentLimit,
    defaultPower,
    requestedLoad,
    requestedDischargingLoad,
    loadLimit,
    dischargingLoadLimit,
    chargingPowerRequested,
    dischargingPowerRequested,
    chargingPowerLimit,
    dischargingPowerLimit,
    sessionType,
    presentLoadPhA,
    presentLoadPhB,
    presentLoadPhC,
    presentPowerPhA,
    presentPowerPhB,
    presentPowerPhC,
    presentVoltagePhA,
    presentVoltagePhB,
    presentVoltagePhC,
    sessionEnergy,
    condition,
    minLoadLimit,
  } = props;

  let staticParams = [
    { label: 'Charger ID', value: renderValue(chargerUuid) },
  ];

  if (isDemo === 'v2x') {
    staticParams.push(
      { label: 'Bidirectional Charger', value: '✓' },
    );
  }

  staticParams = staticParams.concat(
    [
      { label: 'Nominal Voltage', value: renderValue(nominalVoltage, 'V') },
      { label: 'Max Offline Load', value: renderValue(offlineCurrentLimit, 'A') },
      { label: 'Max Offline Power', value: renderValue(defaultPower, 'kW', 0.001) },
      { label: 'Min Load', value: renderValue(minLoadLimit, 'A') },
    ],
  );

  const dynamicParams = [
    { label: 'Requested Charging Load', value: renderValue(requestedLoad, 'A') },
    { label: 'Requested Discharging Load', value: renderValue(requestedDischargingLoad, 'A') },
    { label: 'Requested Charging Power', value: renderValue(chargingPowerRequested, 'kW', 0.001) },
    { label: 'Requested Discharging Power', value: renderValue(dischargingPowerRequested, 'kW', 0.001) },
    { label: 'Charging Load Limit', value: renderValue(loadLimit, 'A') },
    { label: 'Discharging Load Limit', value: renderValue(dischargingLoadLimit, 'A') },
    { label: 'Charging Power Limit', value: renderValue(chargingPowerLimit, 'kW', 0.001) },
    { label: 'Discharging Power Limit', value: renderValue(dischargingPowerLimit, 'kW', 0.001) },
    { label: 'Session Type', value: renderValue(sessionType) },
    ...renderPhasesParams({
      presentLoadPhA,
      presentLoadPhB,
      presentLoadPhC,
      presentPowerPhA,
      presentPowerPhB,
      presentPowerPhC,
      presentVoltagePhA,
      presentVoltagePhB,
      presentVoltagePhC,
      sessionEnergy,
    }, true),
  ];

  return (
    <BaseNode
      {...props}
      infoMarkers={condition === 'INACTIVE' ? <InactiveMarker /> : null}
      staticParams={staticParams}
      dynamicParams={dynamicParams}
    />
  );
}

export default ChargerNode;
